export const OptInInput = ({}) => {
  return (
    <div className="flex flex-row gap-4 items-start">
      <input type="checkbox" name="opt-in" className="checkbox" />
      <small className="text-default">
        By checking this box, I agree to be contacted by KKI Ventures, Inc (Marshall Reddick) via
        call, email, and text for lending, mortgage, and real estate services. You can reply "STOP"
        to opt-out. Message and data rates may apply. Message frequency may vary, text "HELP" to{' '}
        <a className="link text-link no-underline" href="tel:+18885827231">
          (888) 582-7231
        </a>{' '}
        for assistance. For more information refer to our{' '}
        <a
          href={`${import.meta.env.VITE_WEBSITE_URL}/terms-and-conditions`}
          target="_blank"
          rel="noreferrer"
          className="link text-link no-underline"
        >
          Terms and Conditions
        </a>{' '}
        and{' '}
        <a
          href={`${import.meta.env.VITE_WEBSITE_URL}/privacy-policy`}
          target="_blank"
          rel="noreferrer"
          className="link text-link no-underline"
        >
          Privacy Policy
        </a>{' '}
        on our website.
      </small>
    </div>
  );
};
